/**
 * Browser Support Module
 *
 * This Module checks for various supported browser features
 *
 * NOTE: Before making writing any number of intricate checks for browser support
 * consult with the Modernizr to see if that feature is already supported and if
 * updating the Modernizr plugin is a better solution.
 *
 * @author Paige Ponzeka (pponzeka@yext.com)
 */
goog.module('yext.browser');
goog.module.declareLegacyNamespace();

/**
 * @return {boolean} true if the browser has support for the HTML5 history API
 */
function hasHistory() {
  return (window.history && 'pushState' in window.history);
}

/**
 *
 * @return {boolean} true if the browser has support for drag and drop events
 */
function hasDragAndDropEvents() {
  // since we aren't responsive and don't support mobile,
  // this doesn't support checking mobile browsers for support
  var div = document.createElement('div');
  return ('draggable' in div) || ('ondragstart' in div && 'ondrop' in div);
}

/**
 * @return {boolean} true if the browser supports File Reader
 */
function hasFileAPI() {
  return !!window.FileReader;
}

/**
 * Note: Just checking support for drag and drop  is not enough for mobile browsers
 * since it seems to return false positives for some browsers
 * See: https://github.com/Modernizr/Modernizr/issues/637
 * @return {boolean} true if the browser supports dragging and dropping of files
 */
function hasDragAndDrop() {
  return (hasDragAndDropEvents() && (hasFileAPI()));
}

/**
 * @return {boolean} true if the browser supports canvas
 */
function hasCanvasSupport() {
  return $.isFunction($('<canvas>')[0].getContext);
}

exports = {
  hasHistory,
  hasDragAndDropEvents,
  hasFileAPI,
  hasDragAndDrop,
  hasCanvasSupport,
};
